
import CandidateList from "@/components/candidates/CandidateList";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useState } from "react";
import { Users, PieChart } from "lucide-react";
import InsightsTab from "@/components/ai-hub/InsightsTab";
import MatchingTab from "@/components/ai-hub/MatchingTab";
import { Routes, Route, useParams } from "react-router-dom";
import CandidateDetail from "./CandidateDetail";

const CandidatesMain = () => {
  const [activeView, setActiveView] = useState<"list" | "insights" | "matching">("list");
  
  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-3xl font-bold">Candidates</h1>
        <div className="flex items-center gap-3">
          <div className="text-sm text-muted-foreground hidden md:block">
            Manage your candidate pipeline and track their progress.
          </div>
          <Tabs value={activeView} onValueChange={(value) => setActiveView(value as typeof activeView)} className="w-fit">
            <TabsList>
              <TabsTrigger value="list" className="flex items-center gap-1">
                <Users className="h-4 w-4" />
                <span className="hidden md:inline">Candidates</span>
              </TabsTrigger>
              <TabsTrigger value="insights" className="flex items-center gap-1">
                <PieChart className="h-4 w-4" />
                <span className="hidden md:inline">Insights</span>
              </TabsTrigger>
              <TabsTrigger value="matching" className="flex items-center gap-1">
                <Users className="h-4 w-4" />
                <span className="hidden md:inline">Job Matching</span>
              </TabsTrigger>
            </TabsList>
          </Tabs>
        </div>
      </div>
      
      <Tabs value={activeView} onValueChange={(value) => setActiveView(value as typeof activeView)}>
        <TabsContent value="list">
          <CandidateList />
        </TabsContent>
        
        <TabsContent value="insights">
          <InsightsTab />
        </TabsContent>
        
        <TabsContent value="matching">
          <MatchingTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

const Candidates = () => {
  return (
    <Routes>
      <Route path="/" element={<CandidatesMain />} />
      <Route path="/:id" element={<CandidateDetail />} />
    </Routes>
  );
};

export default Candidates;
